import React, { useEffect, useState } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import IntlMessages from "@util/IntlMessages";
import { useSelector } from "react-redux";
import { getList } from "services/api/Api";
import "./summary.less";
import SummaryHoppsSettings from "../WidgetsSettings/SummaryHopps/SummaryHoppsSettingsModal";
import { parseFile } from "../../ParseFile/ParseFile";
import { isActivePublicUser } from "../../../util/Scripts";
import { Avatar } from "../../BP2Components";

const SummaryHopps = ({ value, role }) => {
   const [columns, setColumns] = useState([]);
   const [levelsNumber, setLevelsNumber] = useState(0);
   const [availableLevels, setAvailableLevels] = useState([]);
   const [listValues, setListValues] = useState({
      hopps: "",
      position: "",
      level: "",
      points: "",
      leftPoints: "",
      levelNumber: "",
   });

   const { firstName, avatarLink } = useSelector(({ user }) => user);
   useEffect(() => {
      let sum = 0;

      if (value.columnToDisplayHopps) {
         getList(value.listId, 1, 10).then((res) => {
            const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
            setColumns(responseData.columns);
            responseData.data.map((row) => {
               setListValues({
                  hopps: row[value.columnToDisplayHopps],
                  position: row[value.columnToDisplayPosition],
                  level: row[value.columnToDisplayLevel],
                  points: row[value.columnToDisplayPoints],
                  leftPoints: row[value.columnToDisplayLeftPoints],
                  levelNumber:
                     typeof row[value.columnToCalculateTimeline] === "object"
                        ? row[value.columnToCalculateTimeline].value
                        : row[value.columnToCalculateTimeline],
               });
               if (row[value.columnToDisplayHopps] !== null) {
                  sum = sum + parseFloat(row[value.columnToDisplayHopps]);
               }
            });
         });
      }
      const levels = [];
      getList(value.timelineListId, 1, 10).then((res) => {
         const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
         responseData.data.map((level) => {
            const copyParsedId = parseFile(
               level.Logo?.altUrl ?? level.Logo?.altUrl1 ?? level.Logo?.fileUrl,
            );
            levels.push({
               name: level.Nazwa,
               id: copyParsedId,
               number: level.Poziom,
            });
         });
         setLevelsNumber(responseData.data.length);
      });
      setAvailableLevels(levels);
   }, [value]);

   return (
      <div className="summaryWidget ">
         <Widget
            styleName="gx-mt-3"
            bgColor={value.backgroundColourHex}
            className="summaryWidget"
            role={role}
            extra={
               role === "OWNER" || role === "MODERATOR" ? (
                  <SettingsModal
                     widgetName={value.name}
                     widgetId={value.id}
                     icon="setting"
                     deleteIcon="true"
                     children={<SummaryHoppsSettings value={value} columns={columns} />}
                  />
               ) : null
            }
         >
            <>
               {value.columnToDisplayHopps ? (
                  <div>
                     <div
                        style={{
                           marginTop: "1rem",
                           display: "flex",
                           flexDirection: "column",
                           alignItems: "center",
                        }}
                     >
                        <div>
                           <Avatar
                              src={avatarLink}
                              className="gx-size-120 gx-pointer gx-ml-4 gx-mb-1"
                              alt="avatar"
                           />
                           <a
                              href={`${value.redirectUrl}?initialPage=${2}`}
                              className="icon icon-edit pencil-redirect"
                           />
                        </div>
                        <span style={{ fontSize: "x-large", marginTop: "1rem" }}>
                           <IntlMessages id="summaryHopps.hi" /> {firstName}
                        </span>
                        <div
                           style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: "x-large",
                           }}
                        >
                           {availableLevels.map((level) => {
                              if (level.number == listValues.levelNumber) {
                                 return (
                                    <img
                                       alt="level"
                                       src={`https://drive.google.com/thumbnail?authuser=0&id=${
                                          level.id
                                       }&sz=h${40}`}
                                       className="image-icon gx-mr-1"
                                    />
                                 );
                              }
                           })}
                           <div
                              style={{ display: "flex", flexDirection: "row", marginTop: "1rem" }}
                           >
                              <IntlMessages id="summaryHopps.youAre" />{" "}
                              <span
                                 style={{
                                    color: value.textColor,
                                 }}
                              >
                                 &nbsp;
                                 {typeof listValues.position === "object"
                                    ? listValues.position.value
                                    : listValues.position}
                              </span>
                           </div>
                        </div>
                        <div
                           style={{
                              display: "flex",
                              flexDirection: "row",
                              fontSize: "x-large",
                              marginTop: "1rem",
                           }}
                        >
                           <IntlMessages id="summaryHopps.ranking" />
                           {": "}
                           <span style={{ color: value.textColor }}>
                              &nbsp;
                              {typeof listValues.level === "object"
                                 ? listValues.level.value
                                 : listValues.level}
                           </span>
                        </div>
                        <div
                           style={{
                              display: "flex",
                              flexDirection: "row",
                              fontSize: "x-large",
                              marginTop: "1rem",
                           }}
                        >
                           <IntlMessages id="summaryHopps.leftPoints" />{" "}
                           <span style={{ color: value.textColor }}>
                              {typeof listValues.leftPoints === "object"
                                 ? listValues.leftPoints.value
                                 : listValues.leftPoints}{" "}
                           </span>
                        </div>
                     </div>
                     {availableLevels && availableLevels.length > 0 ? (
                        <div className="gx-mt-4 gx-ml-3 gx-mr-3">
                           <div className="green-timeline">
                              <div
                                 className="inside-timeline"
                                 style={{
                                    width: `${
                                       (parseInt(listValues.levelNumber, 10) /
                                          parseInt(levelsNumber, 10)) *
                                          100 +
                                       10
                                    }%`,
                                 }}
                              ></div>
                           </div>
                           <div className="gx-flex-row-reverse gx-align-items-baseline gx-justify-content-between timeline-settings">
                              {availableLevels
                                 ? availableLevels.map((level) => (
                                      <div className="gx-flex-column gx-align-items-center gx-justify-content-end">
                                         <img
                                            alt="level"
                                            src={`https://drive.google.com/thumbnail?authuser=0&id=${
                                               level.id
                                            }&sz=h${80}`}
                                            className="image-icon"
                                         />{" "}
                                         {level.name}
                                      </div>
                                   ))
                                 : null}
                           </div>
                        </div>
                     ) : null}
                  </div>
               ) : (
                  <p className="gx-pl-3">
                     <IntlMessages id="timeline.selectListIdAndAttributes" />
                  </p>
               )}
            </>
         </Widget>
      </div>
   );
};

export default SummaryHopps;
